var m = require('mithril');
var layout = require('../layout/layout');
var diagramDetail = require('./diagramDetail');

module.exports = {
  '/diagram/:id': {
    view: function () {
      return m(layout, m(diagramDetail));
    },
  },
};
